// extracted by mini-css-extract-plugin
export default {"tipContainer":"tip_tipContainer__76hf8","tipHeader":"tip_tipHeader__5IBGu","tipContent":"tip_tipContent__oYzwz"};